import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

const defaultSignError = 'An unexpected error occurred while getting Document';

export interface SignLoiArg {
    engagementId: number;
    documentDetailsId: string;
}

export const SignLoi = createAsyncThunk(
    'loiSigning/sign',
    async (arg: SignLoiArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${arg.engagementId}/LoiSigning/${arg.documentDetailsId}/Sign`
            );

            if (response?.status !== 200) {
                throw new Error(response?.response?.data?.title || defaultSignError);
            }

            return response.data as number;
        } catch (error) {
            createNotification(
                error instanceof Error && error.message && !(error as { isAxiosError?: boolean }).isAxiosError
                    ? error.message
                    : defaultSignError,
                'error'
            );
            throw error;
        }
    }
);
